// 서비스 티켓 만들기 진입 상태(refer, extraItem)에서 제품·사이트 맥락 객체를 뽑는다.
// PRODUCTERROR/PRODUCTNORMAL: product=extraItem, site={ siteId: 제품의 siteId }
// SITENORMAL: site=extraItem, product={}
export const getReferExtra = (refer, extraItem, itemname) => {
	switch (refer) {
		case 'PRODUCTERROR':
		case 'PRODUCTNORMAL':
			if (itemname === 'product') return extraItem;
			if (itemname === 'site') return extraItem?.siteId ? { siteId: extraItem.siteId } : {};
			return {};
		case 'SITENORMAL':
			return itemname === 'site' ? extraItem : {};
		default:
			return {};
	}
};
